export default "__VITE_ASSET__BR1bRVL6__"